import type { PropType } from 'virtual-vue';

export const props = {
  modelValue: {
    type: [String, Number],
    default: '',
  },

  /** Vue 2 v-model 兼容 */
  value: {
    type: [String, Number],
    default: '',
  },

  placeholder: {
    type: String,
    default: '请输入内容',
  },

  disabled: {
    type: Boolean,
    default: false,
  },

  readonly: {
    type: Boolean,
    default: false,
  },

  maxlength: {
    type: Number,
    default: 500,
  },

  showWordLimit: {
    type: Boolean,
    default: true,
  },

  rows: {
    type: Number,
    default: 3,
  },

  autosize: {
    type: [Boolean, Object] as PropType<boolean | { minRows?: number; maxRows?: number }>,
    default: false,
  },

  autofocus: {
    type: Boolean,
    default: false,
  },

  name: {
    type: String,
    default: '',
  },

  /** LiteApp 专属：键盘弹起时是否自动上推页面 */
  adjustPosition: {
    type: Boolean,
    default: false,
  },
};
